module.exports = __webpack_public_path__ + "html/studio-header_5c49baf015db3e2f3d453fcf06ca447c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio-header.html
// module id = 1aEF
// module chunks = 151